import React from "react"

import { localizer } from '../../../../Translator.js'

import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from "@material-ui/core"
import Chip from "@material-ui/core/Chip"
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import Alert from '@material-ui/lab/Alert'
import { TableContainer, TableHead, TableBody, TableCell } from "@material-ui/core"
import { Paper } from "@material-ui/core"


import { FeatureRow } from './FeatureRow.js'
import { FeatureModal } from "./FeatureModal.js"

import { TableStyled } from '../../../common/TableStyled.js'
import { TableRowHeaderStyled } from '../../../common/TableStyled.js'
import ScreenHeading from '../../../common/ScreenHeading';
import { GridPrice } from '../../../common/outbox/features/FeaturesStyled.js'
import TooltipStyled from "../../../common/TooltipStyled"

import CurrencyCustom from "../../../Utilities/CurrencyCustom.js"
import { SnackbarCustom } from "../../../Utilities/SnackbarCustom.js"

import OutboxCli from "../../../../sdk/OutboxCli.js"


/**
 * Form to select shipment features.
 */
export class OutboxFeatures extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // Represents global shipment list given by parent component to be updated
      shipments: [],

      // Displaying the price in EUR
      priceFormat: "",
      priceFormatNoVat: "",

      printColor: false,
      printDuplex: false,

      // to OCR: rectangle in draft
      document: null,
      referenceLeft: 11,
      referenceTop: 17,
      referenceWidth: 26,
      referenceHeight: 6,

      // OCR errors
      message: null,
      severity: "error",

      //OCR modal
      openOcrReferenceModal: false,
     
      enabledColorOption: false,
      enabledDuplexOption: false,
    }
  }

  /**
   * Updates the current state with the features data from the parent component state
   */
  async componentDidMount() {

    let shipment = this.props.shipments && this.props.shipments.length > 0 ? this.props.shipments[0] : null
    if (!shipment) return

    //print option by mapping
    let mapping = null
    let product = (this.props.products && this.props.products.length > 0) ? this.props.products.find(p => p.productCode === shipment.features.productCode) : null

    // First, filter mappings that match both country and postal code
    let specificMappings = product.mapping.filter(m =>
      m.destinationCountryIso &&
      m.destinationCountryIso.toUpperCase().trim() === shipment.destinationAddress.countryIso.toUpperCase().trim() &&
      m.destinationPostalCode &&
      shipment.destinationAddress.postalCode.toUpperCase().trim().startsWith(m.destinationPostalCode.toUpperCase().trim())
    );

    // If there are specific mappings, use only those
    if (specificMappings.length > 0) {
      mapping = specificMappings;
    } else {
      // Otherwise, filter mappings that match country and have null postal code
      mapping = product.mapping.filter(m =>
        (
          m.destinationCountryIso &&
          m.destinationCountryIso.toUpperCase().trim() === shipment.destinationAddress.countryIso.toUpperCase().trim() &&
          m.destinationPostalCode == null
        )
        ||
        (
          m.destinationCountryIso == null && m.destinationPostalCode == null
        )
      );
    }

    if (!mapping || mapping.length === 0) {
      this.setState({ message: localizer.NoMappingFound, severity: "error" })
      return
    } 

    mapping = mapping[0]
    let printColor = shipment.features.printColor !== null ? shipment.features.printColor : mapping.printColor
    let printDuplex = shipment.features.printDuplex !== null ? shipment.features.printDuplex : mapping.printDuplex

    this.setState({ printColor: printColor, printDuplex: printDuplex, enabledColorOption: mapping.enabledColorOption, enabledDuplexOption: mapping.enabledDuplexOption, shipments: this.props.shipments },
      async () => {
        let priceTotal = 0
        let priceTotalNoVat = 0
        const shipments = await Promise.all(
          this.state.shipments.map(async shipment => {
            let shipmenttmp = { ...shipment, features: { ...shipment.features, printColor: printColor, printDuplex: printDuplex } }
            const priceDetails = await this.props.calculateShipmentPrice(shipmenttmp)

            if (!priceDetails) {
              // Manejar el caso en el que priceDetails es null
              this.setState({ message: "Error calculating shipment price", severity: "error" })
              return shipmenttmp
            }
            let shipmentaux = {
              ...shipmenttmp,
              features: {
                ...shipmenttmp.features,
                price: priceDetails.shipmentPriceVat,
                priceFirstSheet: priceDetails.priceFirstSheet,
                priceNextSheet: priceDetails.priceNextSheet,
                deliveryPrice: priceDetails.deliveryPrice,
                vat: priceDetails.vat
              }
            }
            priceTotal = priceTotal + priceDetails.shipmentPriceVat
            priceTotalNoVat = priceTotalNoVat + priceDetails.shipmentPriceNoVat


            return shipmentaux
          })
        )
        let priceFormat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotal / 100)
        let priceFormatNoVat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotalNoVat / 100)
        this.setState({ shipments: shipments, priceFormat: priceFormat, priceFormatNoVat: priceFormatNoVat })
      })
    
    
    let left = 11
    let top = 17
    let width = 26
    let height = 6
    if (this.props.billable && this.props.billable.referenceBox && this.validateBoxSelector(this.props.billable.referenceBox)) {
      left = this.props.billable.referenceBox.left
      top = this.props.billable.referenceBox.top
      width = this.props.billable.referenceBox.width
      height = this.props.billable.referenceBox.height
    }
    
    this.setState({
      referenceLeft: left,
      referenceTop: top,
      referenceWidth: width,
      referenceHeight: height,
    })
    this.doDrafReference()
  }

  async componentDidUpdate(prevProps) {

    if (this.props.shipments === prevProps.shipments) return

    let shipment = this.props.shipments && this.props.shipments.length > 0 ? this.props.shipments[0] : null
    if (!shipment) return

    //print option by mapping
    let mapping = null
    let product = (this.props.products && this.props.products.length > 0) ? this.props.products.find(p => p.productCode === shipment.features.productCode) : null
       
    mapping = product.mapping && product.mapping.map(m => {
      if (m.destinationCountryIso !== null && m.destinationCountryIso.toUpperCase().trim() !== shipment.destinationAddress.countryIso.toUpperCase().trim()) return null
          
      if (m.destinationPostalCode !== null && !shipment.destinationAddress.postalCode.toUpperCase().trim().startsWith(m.destinationPostalCode.toUpperCase().trim())) return null
                
      return m
    })
    mapping = mapping.filter(function (el) {
      return el != null;
    });

    if (!mapping) return

    mapping = mapping[0]
    let printColor = shipment.features.printColor !== null ? shipment.features.printColor : mapping.printColor
    let printDuplex = shipment.features.printDuplex !== null ? shipment.features.printDuplex : mapping.printDuplex
            
    this.setState({ printColor: printColor, printDuplex: printDuplex, enabledColorOption: mapping.enabledColorOption, enabledDuplexOption: mapping.enabledDuplexOption, shipments: this.props.shipments },
      async () => {
        let priceTotal = 0
        let priceTotalNoVat = 0
        const shipments = await Promise.all(
          this.state.shipments.map(async shipment => {
            let shipmenttmp = { ...shipment, features: { ...shipment.features, printColor: printColor, printDuplex: printDuplex } }
            const priceDetails = await this.props.calculateShipmentPrice(shipmenttmp)

            if (!priceDetails) {
              // Manejar el caso en el que priceDetails es null
              this.setState({ message: "Error calculating shipment price", severity: "error" })
              return shipmenttmp
            }
            let shipmentaux = {
              ...shipmenttmp,
              features: {
                ...shipmenttmp.features,
                price: priceDetails.shipmentPriceVat,
                priceFirstSheet: priceDetails.priceFirstSheet,
                priceNextSheet: priceDetails.priceNextSheet,
                deliveryPrice: priceDetails.deliveryPrice,
                vat: priceDetails.vat
              }
            }
            priceTotal = priceTotal + priceDetails.shipmentPriceVat
            priceTotalNoVat = priceTotalNoVat + priceDetails.shipmentPriceNoVat

            return shipmentaux
          })
        )
        let priceFormat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotal / 100)
        let priceFormatNoVat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotalNoVat / 100)
        this.setState({ shipments: shipments, priceFormat: priceFormat, priceFormatNoVat: priceFormatNoVat })
      })
    
    let left = 11
    let top = 17
    let width = 26
    let height = 6
    if (this.props.billable && this.props.billable.referenceBox && this.validateBoxSelector(this.props.billable.referenceBox)) {
      left = this.props.billable.referenceBox.left
      top = this.props.billable.referenceBox.top
      width = this.props.billable.referenceBox.width
      height = this.props.billable.referenceBox.height
    }
    
    this.setState({
      referenceLeft: left,
      referenceTop: top,
      referenceWidth: width,
      referenceHeight: height,
    },)
    this.doDrafReference()
  }

  /* Request for Base64 of the first draft on the first shipment page when Detect Reference Modal opens */
  doDrafReference = () => {
    
    let draftid = this.props.shipments && this.props.shipments.length > 0 && this.props.shipments[0].pages.length > 0 ? this.props.shipments[0].pages[0].draftId : null
    let pageFirst = this.props.shipments && this.props.shipments.length > 0 && this.props.shipments[0].pages[0].length > 0 ? this.props.shipments[0].pages[0].pageFirst : 1
    if (!draftid) return this.setState({ message: localizer.BoxSelectorNoDocument, severity: "error" })

    OutboxCli.GetDraftPageImage(draftid,
      pageFirst,
      0,
      0,
      100,
      100
    ).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ message: response.substring(response.indexOf(' ')), severity: "error" })
      } else {
        this.setState({ document: response })
      }
    })
  }
  
  /* check if the box is valid to take its coordinates
   * It is defined but some of its coordinates are missing
   * Some of its coordinates are negative
   * The defined area is zero (a line, a point
  */
  validateBoxSelector = (Box) => {
    if (!Box.width || !Box.height || !Box.left || !Box.top) return false
    if (Box.width < 0 || Box.height < 0 || Box.left < 0 || Box.top < 0) return false
    if (Box.width === 0 || Box.height === 0 || (Box.left === Box.top)) return false
    
    return true
  }

  doOpenOcrReferenceModal = () => {
    this.setState({ openOcrReferenceModal: true })
  }

  doCloseOcrReferenceModal = () => {
    this.setState({ openOcrReferenceModal: false })
  }

  /* Set empty reference for all shipments, used when user wants to clean the reference detected by OCR */
  doCleanReference = () => {
    let shipments = this.state.shipments.map(s => {
      let shipmenttmp = { ...s, features: { ...s.features, reference: "" } }
      return shipmenttmp
    })
    this.setState({ shipments: shipments })

  }

  
  /**
   * Called when the user changes the selection of printing ink option.
   */
  handleInkChange = async (event) => {
    let printColor = event.target.value === "colour"
    this.setState({ printColor: printColor })
    let priceTotal = 0
    let priceTotalNoVat = 0

    const shipments = await Promise.all(
      this.state.shipments.map(async shipment => {
        shipment.features.printColor = printColor
        let shipmenttmp = { ...shipment, features: { ...shipment.features, printColor: printColor } }
        const priceDetails = await this.props.calculateShipmentPrice(shipmenttmp)

        if (!priceDetails) {
          // Manejar el caso en el que priceDetails es null
          this.setState({ message: "Error calculating shipment price", severity: "error" })
          return shipmenttmp
        }
        let shipmentaux = {
          ...shipmenttmp,
          features: {
            ...shipmenttmp.features,
            price: priceDetails.shipmentPriceVat,
            priceFirstSheet: priceDetails.priceFirstSheet,
            priceNextSheet: priceDetails.priceNextSheet,
            deliveryPrice: priceDetails.deliveryPrice,
            vat: priceDetails.vat
          }
        }
        priceTotal = priceTotal + priceDetails.shipmentPriceVat
        priceTotalNoVat = priceTotalNoVat + priceDetails.shipmentPriceNoVat


        return shipmentaux
      })
    )
    let priceFormat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotal / 100)
    let priceFormatNoVat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotalNoVat / 100)
    this.setState({ shipments: shipments, priceFormat: priceFormat, priceFormatNoVat: priceFormatNoVat })

  }

  /**
     * Called when the user changes the selection of printing sides (simplex/duples).
     */
  handleSidesChange = async (event) => {
    let printDuplex = event.target.value === "duplex"
    this.setState({ printDuplex: printDuplex })

    let priceTotal = 0
    let priceTotalNoVat = 0

    const shipments = await Promise.all(
       
      this.state.shipments.map(async shipment => {
        shipment.features.printDuplex = printDuplex
        let shipmenttmp = { ...shipment, features: { ...shipment.features, printDuplex: printDuplex } }
        const priceDetails = await this.props.calculateShipmentPrice(shipmenttmp)

        if (!priceDetails) {
          // Manejar el caso en el que priceDetails es null
          this.setState({ message: "Error calculating shipment price", severity: "error" })
          return shipmenttmp
        }
        let shipmentaux = {
          ...shipmenttmp,
          features: {
            ...shipmenttmp.features,
            price: priceDetails.shipmentPriceVat,
            priceFirstSheet: priceDetails.priceFirstSheet,
            priceNextSheet: priceDetails.priceNextSheet,
            deliveryPrice: priceDetails.deliveryPrice,
            vat: priceDetails.vat
          }
        }
        priceTotal = priceTotal + priceDetails.shipmentPriceVat
        priceTotalNoVat = priceTotalNoVat + priceDetails.shipmentPriceNoVat


        return shipmentaux
      })
    )
    let priceFormat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotal / 100)
    let priceFormatNoVat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotalNoVat / 100)
    this.setState({ shipments: shipments, priceFormat: priceFormat, priceFormatNoVat: priceFormatNoVat })
  }

  /**
   * Called when the user changes the selection of printing sides (simplex/duples).
   */
  handleFeaturesChange = async (option, value) => {
    let printColor = option === "printColor" ? value : this.state.printColor
    let printDuplex = option === "printDuplex" ? value : this.state.printDuplex
    
    this.setState({ printDuplex: printDuplex, printColor: printColor })

    let priceTotal = 0
    let priceTotalNoVat = 0

    const shipments = await Promise.all(
       
      this.state.shipments.map(async shipment => {
        shipment.features.printDuplex = printDuplex
        shipment.features.printColor = printColor
        let shipmenttmp = { ...shipment, features: { ...shipment.features, printColor: printColor, printDuplex: printDuplex } }
        const priceDetails = await this.props.calculateShipmentPrice(shipmenttmp)
        
        if (!priceDetails) {
          // Handle the case where priceDetails is null
          this.setState({ message: "Error calculating shipment price", severity: "error" })
          return shipmenttmp
        }
        let shipmentaux = {
          ...shipmenttmp,
          features: {
            ...shipmenttmp.features,
            price: priceDetails.shipmentPriceVat,
            priceFirstSheet: priceDetails.priceFirstSheet,
            priceNextSheet: priceDetails.priceNextSheet,
            deliveryPrice: priceDetails.deliveryPrice,
            vat: priceDetails.vat
          }
        }
        priceTotal = priceTotal + priceDetails.shipmentPriceVat
        priceTotalNoVat = priceTotalNoVat + priceDetails.shipmentPriceNoVat

        return shipmentaux
      })
    )
    let priceFormat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotal / 100)
    let priceFormatNoVat = CurrencyCustom.currencyFormatter(CurrencyCustom.CURRENCIES.EUR, priceTotalNoVat / 100)
    this.setState({ shipments: shipments, priceFormat: priceFormat, priceFormatNoVat: priceFormatNoVat })
  }

  handleFeatures = (shipment, index) => {
    let shipments = this.state.shipments.map((s, i) => {
      if (index === i) return shipment

      return s
    })
    this.setState({ shipments: shipments });
 
  }

  /**
   * Send component data to update parent component state
   */
  handleStep = (event) => {
    var direction = event.currentTarget.name

    const validationError = this.getReferenceValidationError(this.state.shipments)
    if (validationError === "requiredNT2") {
      this.setState({ message: localizer.ShipmentNT2ReferenceRequired, severity: "error" })
      return
    }

    if (validationError === "maxLength") {
      this.setState({ message: localizer.ShipmentReferenceMaxLength, severity: "error" })
      return
    }

    this.props.handleOutboxState(this.state.shipments, null, 4, direction, null)
  }

  getReferenceValidationError = (shipments) => {
    for (const shipment of shipments) {
      if (shipment.features && shipment.features.productCode === "NT2") {
        if (!shipment.features.reference || shipment.features.reference.length === 0) {
          return "requiredNT2"
        }
      }

      if (shipment.features && shipment.features.reference && shipment.features.reference.length > 100) {
        return "maxLength"
      }
    }

    return null
  }
 
  doRecalcuteReferences = async (l, t, w, h) => {
    this.setState({ isLoading: true, openOcrReferenceModal: false })

    const shipments = await Promise.all(
      this.state.shipments.map(async shipment => {
        const reference = await this.getReference(shipment, l, t, w, h)
        let shipmentaux = { ...shipment, features: { ...shipment.features, reference: reference } }
        return shipmentaux
      }))
      
    this.setState({ shipments: shipments, isLoading: false, referenceLeft: l, referenceTop: t, referenceWidth: w, referenceHeight: h })
      
  }

  getReference = async (shipment, left, top, width, height) => {
    let draftid = shipment.pages.length > 0 ? shipment.pages[0].draftId : null
    let pageFirst = shipment.pages.length > 0 ? shipment.pages[0].pageFirst : 1
    let reference = null

    await OutboxCli.DetectReferenceInPage(draftid, pageFirst, left, top, width, height).then(response => {
      //Regular expression pattern to check for any matching set of HTML tags in a string. Note: They must be closed (i.e. <b>this</b>)
      let htmlRegex = /<\s*([^ >]+)[^>]*>.*?<\s*\/\s*\1\s*>/;
      let isHtml = htmlRegex.test(response.toString());
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ message: response.substring(response.indexOf(' ')), severity: "error" })
      } else if (response !== null && isHtml) {
        this.setState({ message: localizer.ReferenceError, severity: "warning" })
      } else {
        reference = this.MultiSpace(response.replace("\t", " "), " ")
      }
    })
    return reference

  }
  handleonClose = () => {
    this.setState({ message: null })
  }

  // Replace two or more consecutive spaces with a single space
  MultiSpace(text) {
    return text.replace(/ {2,}/g, ' ');
  }

  render() {
    let left = this.state.referenceLeft
    let top = this.state.referenceTop
    let width = this.state.referenceWidth
    let height = this.state.referenceHeight

    const bwDisabled = this.state.printColor && !this.state.enabledColorOption ? "feature-disabled" : ""
    const bwSelected = !this.state.printColor ? "feature-selected" : ""

    const colourDisabled = !this.state.printColor && !this.state.enabledColorOption ? "feature-disabled" : ""
    const colourSelected = this.state.printColor ? "feature-selected" : ""

    const simplexDisabled = this.state.printDuplex && !this.state.enabledDuplexOption ? "feature-disabled" : ""
    const simplexSelected = !this.state.printDuplex ? "feature-selected" : ""
    
    const duplexDisabled = !this.state.printDuplex && !this.state.enabledDuplexOption ? "feature-disabled" : ""
    const duplexSelected = this.state.printDuplex ? "feature-selected" : ""
    const disabledOCR = this.props.billable && this.props.billable.billableOptions && this.props.billable.billableOptions.disabledOCR ? this.props.billable.billableOptions.disabledOCR : false


    return (
      <React.Fragment>
        <Container className="pt-20">
          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-gear icon-button-header mr-20 ml-20"></i>} title={localizer.NewShipmentInstructionsHeaderText} />
         
          <Grid md={12}>
            <Alert severity="info" >
              <Typography className="typography-generic color-info" variant="caption" display="inline" gutterBottom>{localizer.NewShipmentInstructionsText}</Typography>
            </Alert>
          </Grid>

          <Grid container direction="row" className="container-generic" justify="center" justifycontent="center" alignitems="center">
            {/* Print color features */}
            <Grid container item md={6}>
              <Paper elevation={2} className="m-10" style={{ width: "100%" }}>
                <Typography className="typography-generic medium bigweight secondary">{localizer.PrintColourTitle}
                  <hr className="hr-custom"></hr>
                </Typography>
                <Grid container item md={12}>
                  <Grid item md={6} className="p-10">
                    <Paper elevation={2} className={"feature-container blackwhite " + bwDisabled + " " + bwSelected} onClick={() => { this.state.enabledColorOption && this.handleFeaturesChange("printColor", false) }}>
                      {bwSelected && <Chip className="chip feature-chip"
                        variant="outlined"
                        size="small"
                        icon={<i className="fa-solid fa-check icon-chip"></i>}
                        label={<Typography className="typography-generic xsmall color-white font-weight-bold pl-0">{localizer.Selected}</Typography>}
                      />}
                      <h3><i className="fa-solid fa-circle-half-stroke font-size-16 mr-5"></i>{localizer.BlackAndWhite}</h3>
                      <hr className="mt-10 mb-10"></hr>
                      <Typography className="typography-generic" variant="caption"><i className="fa-solid fa-check color-info mr-5"></i> {localizer.BlackAndWhiteDescription}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item md={6} className="p-10">
                    <Paper elevation={2} className={"feature-container coloured " + colourDisabled + " " + colourSelected} onClick={() => { this.state.enabledColorOption && this.handleFeaturesChange("printColor", true) }}>
                      {colourSelected && <Chip className="chip feature-chip"
                        variant="outlined"
                        size="small"
                        icon={<i className="fa-solid fa-check icon-chip"></i>}
                        label={<Typography className="typography-generic xsmall color-white font-weight-bold pl-0">{localizer.Selected}</Typography>}
                      />}
                      <h3><i className="fa-solid fa-palette font-size-16 mr-5 coloured-text"></i>{localizer.Colour}</h3>
                      <hr className="mt-10 mb-10"></hr>
                      <Typography className="typography-generic" variant="caption"><i className="fa-solid fa-check color-info mr-5"></i>{localizer.ColourDescription}</Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          
            {/* Print simplex/duplex features */}
             
            <Grid container item md={6}>
              <Paper elevation={2} className="m-10" style={{ width: "100%" }}>
                <Typography className="typography-generic medium bigweight secondary">{localizer.PrintSimplexDuplexTitle}
                  <hr className="hr-custom"></hr>
                </Typography>
                <Grid container item md={12}>
                  <Grid item md={6} className="p-10">
                    <Paper elevation={2} className={"feature-container " + simplexDisabled + " " + simplexSelected} onClick={() => { this.state.enabledDuplexOption && this.handleFeaturesChange("printDuplex", false) }}>
                      {simplexSelected && <Chip className="chip feature-chip"
                        variant="outlined"
                        size="small"
                        icon={<i className="fa-solid fa-check icon-chip"></i>}
                        label={<Typography className="typography-generic xsmall color-white font-weight-bold pl-0">{localizer.Selected}</Typography>}
                      />}
                      <h3><i className="fa-solid fa-scroll font-size-16 mr-5"></i>{localizer.SimplexPrinting}</h3>
                      <hr className="mt-10 mb-10"></hr>
                      <Typography className="typography-generic" variant="caption"><i className="fa-solid fa-check color-info mr-5"></i>{localizer.SimplexPrintingDescription}</Typography>
                    </Paper>
                  </Grid>
                  <Grid item md={6} className="p-10">
                    <Paper elevation={2} className={"feature-container " + duplexDisabled + " " + duplexSelected} onClick={() => { this.state.enabledDuplexOption && this.handleFeaturesChange("printDuplex", true) }}>
                      {duplexSelected && <Chip className="chip feature-chip"
                        variant="outlined"
                        size="small"
                        icon={<i className="fa-solid fa-check icon-chip"></i>}
                        label={<Typography className="typography-generic xsmall color-white font-weight-bold pl-0">{localizer.Selected}</Typography>}
                      />}
                      <h3><i className="fa-solid fa-book-open font-size-16 mr-5"></i>{localizer.DuplexPrinting} </h3>
                      <hr className="mt-10 mb-10"></hr>
                      <Typography className="typography-generic" variant="caption"><i className="fa-solid fa-check color-info mr-5"></i>{localizer.DuplexPrintingDescriptionProp1}
                        <TooltipStyled className="tooltip-custom-w" title={<Typography className="typography-generic small">{localizer.DuplexPrintingDescriptionProp2}</Typography>}>
                          <Chip className="eco-tag ml-5" icon={<i className="fa-solid fa-leaf eco-icon" />} label={<Typography className="typography-generic bold">{localizer.PrintEco}</Typography>} /></TooltipStyled>
                      
                      </Typography><br></br>
                      {/* <Typography className="typography-generic" variant="caption"><i className="fa-solid fa-check color-info mr-5"></i>{localizer.DuplexPrintingDescriptionProp2}
                        <Chip className="eco-tag ml-5" icon={<i className="fa-solid fa-leaf eco-icon" />} label={<Typography className="typography-generic bold">{localizer.PrintEco}</Typography>} />
                      </Typography> */}
                    </Paper>
                  </Grid>
                </Grid>
              </Paper>
                  

            </Grid>
            <Grid item md={12}>
              <Alert severity="info" className="pt-10 mr-10">
                <Typography className="typography-generic font-weight-bold color-info" variant="caption" display="inline" gutterBottom>{localizer.PreparedShipments}{this.props.shipments.length}</Typography>
              </Alert>
            </Grid>

            <Grid item md={12} className="pt-10 mr-10">
              {/* reference buttons */}
              <Grid container item md={12} direction="row" justify="flex-end">
                {!disabledOCR && <Button className="button-generic secondary-main-action" startIcon={<i className="fa-solid fa-crop-simple"></i>} variant="contained" name="detectreference" onClick={this.doOpenOcrReferenceModal}>{localizer.ShipmentsDetectRefence}</Button>}
                <Button className="button-generic secondary-main-action ml-5" startIcon={<i className="fa-solid fa-broom"></i>} variant="contained" name="cleanreference" onClick={this.doCleanReference}>{localizer.CleanRefences}</Button>
              </Grid>
              
              <TableContainer component={Paper}>
                <TableStyled>
                  <TableHead>
                    <TableRowHeaderStyled>
                      <TableCell align="center"><Typography className="typography-generic tablerow-header">{localizer.Shipment}</Typography></TableCell>
                      <TableCell align="center"><Typography className="typography-generic tablerow-header">{localizer.ShipmentSummaryIncludedPages}</Typography></TableCell>
                      <TableCell align="center"><Typography className="typography-generic tablerow-header">{localizer.ShipmentSumaryRefence}</Typography></TableCell>
                      <TableCell align="center"><Typography className="typography-generic tablerow-header">{localizer.ShipmentSummaryAddressee}</Typography></TableCell>
                      <TableCell align="center"><Typography className="typography-generic tablerow-header">{localizer.ShipmentSummaryType}</Typography></TableCell>
                      <TableCell align="center"><Typography className="typography-generic tablerow-header">{localizer.ShippingEstimatedCostText}</Typography></TableCell>
                      <TableCell></TableCell>
                    </TableRowHeaderStyled>
                  </TableHead>
                  <TableBody>
                    {this.state.shipments && this.state.shipments.map((shipment, index) => (
                      <FeatureRow key={index} index={index} shipment={shipment} products={this.props.products} billable={this.props.billable} draftsSelected={this.props.draftsSelected} handleFeatures={this.handleFeatures} />
                    ))}
                  </TableBody>
                </TableStyled>
              </TableContainer>
            </Grid>
            <Grid container item md={12} spacing={2} className="m-25">
              <Grid item md={8}>
                <Typography className="typography-generic features-footer">{localizer.FooterAdviceText}</Typography>
              </Grid>
              <GridPrice container item md={4}>
                <Grid item md={9}>
                  <Typography className="typography-generic price-title text-align-left">{localizer.ShippingEstimatedCostTextNoVAT}</Typography>
                  <br></br>
                  <Typography className="typography-generic price-title text-align-left">{localizer.ShippingEstimatedCostText}</Typography>
                </Grid>
                <Grid item md={3}>
                  <Typography className="typography-generic price-title text-align-right">{this.state.priceFormatNoVat}</Typography>
                  <br></br>
                  <Typography className="typography-generic price-title text-align-right">{this.state.priceFormat}</Typography>
                </Grid>
              </GridPrice>
            </Grid>
          </Grid>

          {/* Step buttons */}
          <Grid container direction="row" className="pt-20">
            <Grid item md={6}>
              <Button className="button-generic secondary" variant="contained" name="previous" onClick={this.handleStep}>{localizer.Previous}</Button>
            </Grid>
            <Grid item md={6}>
              <Button className="button-generic primary" variant="contained" name="next" onClick={this.handleStep}>{localizer.Next}</Button>
            </Grid>
          </Grid>
        </Container>

        {/*  ORC Reference Modal  */}
        <FeatureModal openModal={this.state.openOcrReferenceModal} handleCloseModal={this.doCloseOcrReferenceModal} handleAcceptReference={this.doRecalcuteReferences}
          document={this.state.document} left={left} top={top} width={width} height={height}></FeatureModal>
      
        {/* Detect reference error. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
        
       
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/features/OutboxFeatures.js